// 计算长度，中文记2，英文记1
export const getCharLength = (str: string) => {
  return str.split('').reduce((total, char) => {
    // Check if the character is Chinese (including punctuation)
    return total + (/[\u4e00-\u9fa5\u3000-\u303f\uff00-\uff60]/.test(char) ? 2 : 1);
  }, 0);
};
